/**
 * Calculate total price for per dancer pricing
 * 
 * @param {number} basePrice - Base price per dancer
 * @param {number} minDancers - Minimum number of dancers
 * @param {number} maxDancers - Maximum number of dancers
 * @returns {Object} - Object with min and max total prices
 */
export const calculateTotalPrice = (basePrice, minDancers, maxDancers) => {
  if (isNaN(basePrice) || isNaN(minDancers) || isNaN(maxDancers)) {
    return { min: 0, max: 0 };
  }
  
  return {
    min: basePrice * minDancers,
    max: basePrice * maxDancers
  };
}; 